import { selectSalesAgreementId, selectUrlParams } from '@buy-viasat/redux/src/app';
import { AddressType, Coordinates } from '@buy-viasat/redux/src/address';
import { call, put, select, takeLatest } from 'redux-saga/effects';
import { AddOn, LocationInput } from '@buy-viasat/types/build/bv';
import {
  selectCoordinates,
  selectServiceAddressValues,
  selectUnsanitizedAddressLines,
} from '@buy-viasat/redux/src/serviceability';
import { sanitizeAddressLines, selectPlanId } from '@buy-viasat/redux/src/plan';
import { addonActions } from '@buy-viasat/redux/src/addons';
import getAddonsAsync from '../../providers/requests/products/getAddOns';
import clientLogger from '../../utils/clientLogger';
import { adobeTargetDataLayer } from 'shared/containers/Analytics';
import { DataLayerEvents } from 'shared/containers/Analytics/types';
import { benchmark } from 'shared/containers/App/saga';

export function* getAddonsSaga() {
  const { dealerId, partnerId } = yield select(selectUrlParams);
  yield put(addonActions.setIsAddonsLoading(true));
  const planId: string = yield select(selectPlanId);
  const address: AddressType = yield select(selectServiceAddressValues);
  const coordinates: Coordinates = yield select(selectCoordinates);
  const salesAgreementId: string = yield select(selectSalesAgreementId);
  const unsanitizedAddressLines: string[] | null = yield select(selectUnsanitizedAddressLines);
  try {
    // Match getAvailableProducts: send the exact addressLines scrubAddress returned.
    const location: LocationInput = sanitizeAddressLines(
      { address, coordinates } as LocationInput,
      unsanitizedAddressLines,
    );

    const {
      data: { getAddOns },
    } = yield call(getAddonsAsync, {
      location,
      rootProductId: planId,
      dealerId,
      partnerId,
      salesAgreementId,
    });

    adobeTargetDataLayer.push({
      event: DataLayerEvents.AA_EVENT,
      eventData: {
        event: 'addonView',
        addons: getAddOns.map((addon: AddOn) => ({ id: addon.id, name: addon.name })),
      },
    });

    yield put(addonActions.setAvailableAddons(getAddOns));

    yield put(addonActions.setIsAddonsLoading(false));
  } catch (err: any) {
    yield put(addonActions.setIsAddonsLoading(false));
    clientLogger('getAddonsSaga: ', err);
    yield put(addonActions.setIsAddonsError(true));
  }
}

/**
 * Root saga manages watcher lifecycle
 */
export function* addonSaga(): Generator {
  yield takeLatest(addonActions.getAddons.type, benchmark(getAddonsSaga));
}
